
import { mergeData } from 'vue-functional-data-merge'

import { ThemeMixin } from '../../mixins'

export default ThemeMixin.extend({
  name: 'WeveWidgetSkeleton',
  functional: true,
  render(h, { data, injections }) {
    return h(
      'div',
      mergeData(data, {
        staticClass: 'app-widget-skeleton',
        class: {
          'w-theme--light': injections.theme === 'light',
          'w-theme--dark': injections.theme === 'dark',
        },
      }),
      [
        h('div', { staticClass: 'skeleton-element app-widget-skeleton__icon' }),
        h('div', {
          staticClass: 'skeleton-element app-widget-skeleton__content',
        }),
      ],
    )
  },
})
